<template>
  <div class="mainDiv">
    <h3>{{ albumTitle }}</h3>
    <div style="position: relative">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="班级课程" name="1">
          <ClassCourse
            ref="myClassCourse"
            @goLearningOutcomeFromClass="goLearningOutcomeFromClass"
          />
        </el-tab-pane>
        <el-tab-pane label="班级学员" name="2">
          <ClassStudents
            ref="classStudent"
            @addStudents="addStudents"
            @goLearningOutcomeFromStudent="goLearningOutcomeFromStudent"
          />
        </el-tab-pane>
        <el-tab-pane label="学习记录" name="3">
          <LearningRecord ref="learningRecord" />
        </el-tab-pane>
        <el-tab-pane label="学习结果" name="4">
          <ClassLearningOutcome ref="classLearnResult" />
        </el-tab-pane>
        <!-- <el-tab-pane label="学员（导入）列表" name="5">
          <StudentsImportList />
        </el-tab-pane> -->
        <el-tab-pane v-if="addStudentsVisible" label="添加学员" name="6">
          <AddStudents :albumId="id" @closeAddStudents="closeAddStudents" />
        </el-tab-pane>
      </el-tabs>
      <el-button
        type="info"
        style="position: absolute; right: 8px; top: -6px"
        @click="back"
      >
        返回
      </el-button>
    </div>
  </div>
</template>

<script>
import ClassCourse from './classCourse.vue'
import ClassStudents from './classStudents.vue'
import LearningRecord from './learningRecord.vue'
import ClassLearningOutcome from './classLearningOutcome.vue'
import StudentsImportList from './studentsImportList.vue'
import AddStudents from './addStudents.vue'
export default {
  components: {
    ClassCourse,
    ClassStudents,
    LearningRecord,
    ClassLearningOutcome,
    StudentsImportList,
    AddStudents,
  },
  data() {
    return {
      activeName: this.$route.query.tab,
      id: this.$route.query.id,
      albumTitle: this.$route.query.albumTitle,
      addStudentsVisible: false,
      courseId: null,
      uid: null,
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log('handleClick', tab)
      this.courseId = null
      this.uid = null
      if (tab.name !== '6') {
        this.addStudentsVisible = false
      }
    },
    back() {
      this.$router.go(-1)
    },
    addStudents() {
      this.addStudentsVisible = true
      this.activeName = '6'
    },
    goLearningOutcomeFromStudent(id) {
      console.log('goLearningOutcomeFromStudent', id)
      this.uid = id
      this.activeName = '4'
    },
    goLearningOutcomeFromClass(id) {
      this.courseId = id
      this.activeName = '4'
    },
    closeAddStudents() {
      this.addStudentsVisible = false
      this.activeName = '2'
    },
    handleTabData(val) {
      if (val == '1') {
        this.$nextTick(() => {
          this.$refs.myClassCourse.getClassCourseList()
        })
      } else if (val == '2') {
        this.$nextTick(() => {
          console.log('hgjgjsgjh')
          this.$refs.classStudent.getClassStudentList()
        })
      } else if (val == '3') {
        this.$refs.learningRecord.getLearnRecord()
      } else if (val == '4') {
        this.$nextTick(() => {
          this.$refs.classLearnResult.getCourseScore({
            page: '1',
            pageSize: '20',
            uid: this.uid,
            courseId: this.courseId,
          })
        })
      }
    },
  },
  watch: {
    activeName: {
      handler(val) {
        this.handleTabData(val)
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.mainDiv {
  margin-top: 0;
}
</style>